import { createSelector } from '@reduxjs/toolkit';

import { selectGraphologyGraphWithLabwareDependencies } from '../graph/selectors';
import { selectLabwareIdsForTaskByTaskId } from '../selectors/selectLabwareIdsForTaskByTaskId';

// TODO(IL, 2025-01-23): rename, it's only task nodes not nodes in general irght??
export const selectConnectedLeafNodeIds = createSelector(
  selectGraphologyGraphWithLabwareDependencies,
  selectLabwareIdsForTaskByTaskId,
  (graph, labwareByHandleIndexByTaskId): string[] =>
    graph.nodes().filter((node) => {
      const labware = labwareByHandleIndexByTaskId[node];
      const hasConnectionToLabware = labware && Object.keys(labware).length > 0;
      return hasConnectionToLabware && graph.outDegree(node) === 0;
    })
);
